import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyBz2gEh1kVx0GsZ8oMJBufI6d3xkaGelZ8",
  authDomain: "ventra-3381c.firebaseapp.com",
  projectId: "ventra-3381c",
  storageBucket: "ventra-3381c.firebasestorage.app",
  messagingSenderId: "849720487539",
  appId: "1:849720487539:web:319ed93cb3abcb6289c406",
  measurementId: "G-KX73BJJ3CX"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

export { auth, db, GoogleAuthProvider };
